import React from 'react';
import { Link } from 'react-router-dom';
import { Fancybox } from '@fancyapps/ui';
import '@fancyapps/ui/dist/fancybox/fancybox.css';
import {useModal} from "../components/Modal";

const Hp = () => {

    Fancybox.bind('.gal-item', {});

    const { handleShowModal, handleShowModalInfo, handleShowModalInfoTransport } = useModal();

    return (
        <div id="content" className="hp">
            <div className="intro">
                <div className="container">
                    <h1>Modulové dřevostavby na klíč</h1>
                    <h2>s bezkonkurenčním vybavením</h2>
                    <h3>Ceny domů zahrnují:</h3>
                    <ul>
                        <li>DPH 12%</li>
                        <li>základové patky (na rovinatém pozemku)</li>
                        <li>dopravu (v okruhu 100 km od výrobní haly)</li>
                        <li>elektrické venkovní žaluzie</li>
                        <li>tepelné čerpadlo</li>
                        <li>fotovoltaickou elektrárnu</li>
                        <li>projektovou dokumentaci</li>
                        <li>krbová kamna s komínem</li>
                        <li>podlahové vytápění</li>
                    </ul>
                    <div className="circles">
                        <div className="circle-sand">
                            <small>Energetická<br /> třída</small>
                            <span>B</span>
                        </div>
                        <div className="circle-brown">
                            <span>Záruka</span>
                            <strong>20 let</strong>
                            <small>na konstrukci</small>
                        </div>
                    </div>
                </div>
            </div>
            <div className="container">
                <div className="quick-info">
                    <div className="item">
                        <span>Vyrobeno</span>
                        <strong>v ČR</strong>
                    </div>
                    <div className="item">
                        <span>Dodání</span>
                        <strong>do 90 dnů</strong>
                    </div>
                    <div className="item">
                        <span>Bez starostí</span>
                        <strong>Zajistíme vám stavební povolení</strong>
                    </div>
                </div>
                <div className="banner">
                    <h2>Nepřeplácejte za drahé dřevostavby</h2>
                    <h3>Od nás získáte kompletní dům ihned k nastěhování včetně základových patek</h3>
                    <div className="btn-group">
                        <button onClick={handleShowModalInfoTransport} className="bttn-link">Doprava do 100 km od výrobní haly zdarma</button>
                        <a href="/vybaveni-domu" className="bttn">Zobrazit vybavení domů</a>
                    </div>
                </div>
                <div className="catalogue">
                    <div className="heading">
                        <h2>Katalog domů</h2>
                        <button onClick={handleShowModalInfo} className="bttn-link grey">Možnost úpravy dispozice a sklonu střechy</button>
                    </div>
                    <div className="catalogue-items">
                        <div className="item">
                            <div className="preview">
                                <img src="./images/catalogue/2kk/preview.jpg" alt="Dům 2+kk 50m" />
                            </div>
                            <div className="info">
                                <h3>Dům 2+kk 50 m<sup>2</sup></h3>
                                <div className="price">
                                    <span>2 245 000 Kč</span>
                                    <small>včetně DPH a&nbsp;základových patek</small>
                                </div>
                            </div>
                            <div className="params">
                                <ul>
                                    <li>dům na klíč s vnitřním vybavením</li>
                                    <li>střecha 10° - možnost vyššího sklonu</li>
                                    <li>podlahové vytápění</li>
                                    <li>tepelné čerpadlo</li>
                                    <li>rekuperace</li>
                                    <li>...</li>
                                </ul>
                                <Link to="/dum-2kk" className="bttn detail">Zobrazit detail</Link>
                            </div>
                        </div>
                        <div className="item">
                            <div className="preview">
                                <img src="./images/catalogue/3kk/preview.jpeg" alt="Dům 3+kk 80m" />
                            </div>
                            <div className="info">
                                <h3>Dům 3+kk 80 m<sup>2</sup></h3>
                                <div className="price">
                                    <span>3 185 000 Kč</span>
                                    <small>včetně DPH a&nbsp;základových patek</small>
                                </div>
                            </div>
                            <div className="params">
                                <ul>
                                    <li>dům na klíč s vnitřním vybavením</li>
                                    <li>střecha 10° - možnost vyššího sklonu</li>
                                    <li>podlahové vytápění</li>
                                    <li>tepelné čerpadlo</li>
                                    <li>fotovoltaika</li>
                                    <li>...</li>
                                </ul>
                                <Link to="/dum-3kk" className="bttn detail">Zobrazit detail</Link>
                            </div>
                        </div>
                        <div className="item">
                            <div className="preview">
                                <img src="./images/catalogue/4kk/preview.jpg" alt="Dům 4+kk 100m" />
                            </div>
                            <div className="info">
                                <h3>Dům 4+kk 110 m<sup>2</sup></h3>
                                <div className="price">
                                    <span>4 345 000 Kč</span>
                                    <small>včetně DPH a&nbsp;základových patek</small>
                                </div>
                            </div>
                            <div className="params">
                                <ul>
                                    <li>dům na klíč s vnitřním vybavením</li>
                                    <li>střecha 10° - možnost vyššího sklonu</li>
                                    <li>podlahové vytápění</li>
                                    <li>tepelné čerpadlo</li>
                                    <li>fotovoltaika</li>
                                    <li>...</li>
                                </ul>
                                <Link to="/dum-4kk" className="bttn detail">Zobrazit detail</Link>
                            </div>
                        </div>
                    </div>
                </div>
                {/*<div className="platform">
                    <div className="heading">
                        <h2>Půdorys domu</h2>
                        <a href="/pudorys-domu" className="bttn">Více pohledů</a>
                        <button className="bttn-link grey" onClick={handleShowModalInfo}>Možnost úpravy dispozice dle požadavků</button>
                    </div>
                    <div className="inner">
                        <a className="gal-item" href="./images/platform01.jpg" data-fancybox="platform">
                            <img src="./images/platform01.jpg" alt="Půdorys 1" loading="lazy" />
                        </a>
                        <a className="gal-item" href="./images/platform02.jpg" data-fancybox="platform">
                            <img src="./images/platform02.jpg" alt="Půdorys 2" loading="lazy" />
                            <strong>
                                Chcete vyšší střechu s úložným prostorem?
                            </strong>
                            <span>
                                +150 000 Kč
                            </span>
                        </a>
                    </div>
                </div>*/}
                <br />
                <div className="gallery">
                    <h2>Fotogalerie</h2>
                    <div className="gallery-items">
                        <a className="gal-item" href="./images/gallery/01.jpg" data-fancybox="gallery">
                            <img src="./images/gallery/01.jpg" alt="img01" loading="lazy" />
                        </a>
                        <a className="gal-item" href="./images/gallery/02.jpg" data-fancybox="gallery">
                            <img src="./images/gallery/02.jpg" alt="img02" loading="lazy" />
                        </a>
                        <a className="gal-item" href="./images/gallery/03.jpg" data-fancybox="gallery">
                            <img src="./images/gallery/03.jpg" alt="img03" loading="lazy" />
                        </a>
                        <a href="/galerie" className="go-to-gallery">Více<br />fotografií</a>
                    </div>
                </div>
            </div>
            <div className="text-image light-grey-bg">
                <div className="container">
                    <div className="preview">
                        <img src="./images/img01.jpg" alt="Modulová dřevostavba" loading="lazy" />
                    </div>
                    <div className="text">
                        <h3>Co je to modulová dřevostavba?</h3>
                        <p>
                            Modulová dřevostavba je typ moderního bydlení, který kombinuje tradiční vlastnosti
                            dřeva s rychlou a efektivní výstavbou. Stavba je složena z jednotlivých modulů –
                            předem vyrobených částí domu, které se vyrábějí v kontrolovaném prostředí továrny.
                            Tyto moduly mohou obsahovat stěny, podlahy, stropy i celé části interiéru, a po
                            dopravě na váš pozemek se jednoduše spojí do finální podoby domu. Díky tomu je
                            výstavba rychlejší, přesnější a méně závislá na počasí, než u klasické zděné stavby.
                        </p>
                        <p>
                            Modulové domy jsou navíc flexibilní – jednotlivé moduly lze přizpůsobovat nebo
                            později rozšiřovat podle potřeb majitele. Díky těmto vlastnostem se modulové
                            dřevostavby stávají stále populárnější alternativou k tradičním domům.
                        </p>
                        <a href="/specifikace-stavby" className="bttn right">Více informací</a>
                    </div>
                </div>
            </div>
            <div className="container">
                <div className="extra-info">
                    <div className="extra-text">
                        <h3>Co vám můžeme také zajistit</h3>
                        <ul>
                            <li>Zajištění financování (až 90% ceny)</li>
                            <li>Finální úpravy pozemku</li>
                            <li>Stavba garáže či přístavby</li>
                            <li>Dodání a instalace kuchyňské linky</li>
                            <li>Zasíťování pozemku</li>
                        </ul>
                    </div>
                    <div className="extra-banner">
                        <h2>
                            Domy stavíme na klíč včetně <a href="/vybaveni-domu">bohatého vybavení</a>
                        </h2>
                        <h4>Vnitřní dispozice domu upravujeme na míru dle požadavků zákazníka.</h4>
                        <button onClick={handleShowModal} className="bttn center">Má zájem o konzultaci</button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Hp;